import React, {useMemo, useState} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import {Link} from "react-router-dom";
import {Table} from "antd";
import UserImageCircle from "../../../components/UserImageCircle";
import Document from "../../../models/Document";


const TeamScopeProposalEditTab = (props) => {

    const {
        team,
        isLoading: isLoadingCandidate,
        isDisabled,
        onUpdateProposal,
        onChange,
    } = useTeamCandidateScope();

    const teamProposal = useMemo(() => team.proposalDocument(), [
        team?.latest_proposal,
        team?.job_candidate?.proposal_path,
        isDisabled
    ]);
    const [formModel, setFormModel] = useState({latest_proposal: team.latest_proposal});

    return (
        <div className="flex-1 flex flex-row gap-4 items-stretch">

            <div className="basis-1/3 flex flex-col gap-3 items-stretch">
                <div className="proposal-header-container">
                    <p className="font-semibold text-base">
                        Team Proposal Document
                    </p>
                </div>
                <Form
                    showRequired={false}
                    minimal
                    background={'transparent'}
                    title={null}
                    subtitle={null}
                    submitButton={false}
                    onSubmit={null}
                    model={formModel}
                    onChange={(model) => {
                        setFormModel(model)
                    }}
                    isDisabled={isDisabled}
                    fields={[]}
                >
                    <div className="px-4">
                        <FormInputComponent
                            fieldName="latest_proposal"
                            required={false}
                            value={formModel.latest_proposal}
                            type="file"
                            disabled={isDisabled}
                            size={formModel.latest_proposal?.size}
                            viewable={typeof formModel.latest_proposal === 'string'}
                            label={formModel.latest_proposal ? false : <p className="font-semibold text-danger">Upload Team Proposal</p>}
                            fileNameDisplay={(fileData) => {
                                if (typeof formModel.latest_proposal === 'string') {
                                    return team.name + " Proposal";
                                }
                                return formModel.latest_proposal?.name || fileData.name;
                            }}
                        />

                        <div className="mt-4 flex flex-row items-center justify-start gap-2">
                            <Link target="_blank" className="btn btn-outline-dark btn-outline-white" disabled={isDisabled}
                                  to={`/storage/job-candidates/teams/${team.job_candidate?.id}/proposal/doc`}>
                                Download Template
                            </Link>

                            <button className="btn btn-primary" disabled={typeof formModel.latest_proposal === 'string' || isDisabled || !formModel.latest_proposal}
                                    type="button" onClick={() => onUpdateProposal(formModel)}>
                                Upload
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
            <div className="flex-grow flex flex-col items-stretch gap-3">
                <div className="proposal-header-container">
                    <p className="font-semibold text-base">
                        Member Uploaded Slides
                    </p>
                </div>
                <div className="relative flex flex-col items-stretch">
                    <Table
                        rowKey="id"
                        bordered
                        dataSource={team.job_candidate.talent_opps}
                        size="middle"
                        rowClassName="editable-row"
                        pagination={false}
                    >
                        <Table.Column
                            title="Team Member"
                            dataIndex="user"
                            render={user => (
                                <div className="flex flex-col items-stretch">
                                    <div
                                        className="flex flex-row gap-1 items-center">
                                        <UserImageCircle user={user} size={42}/>
                                        <p className="text-sm">
                                            {user.fullName()}
                                        </p>
                                    </div>
                                </div>
                            )}
                        />
                        <Table.Column
                            title="Proposal Documents Uploaded"
                            dataIndex="talent_uploaded_proposals"
                            render={talent_uploaded_proposals => (
                                <div className="flex flex-col divide-y divide-gray-200 items-stretch">
                                    {talent_uploaded_proposals?.length > 0 ? (
                                        TB.map(talent_uploaded_proposals, doc => {
                                            const document = Document.make(doc)
                                            return (
                                                <div className="flex flex-row items-center justify-between gap-2 py-1 px-2" key={doc.id}>
                                                    <div className="flex-1 flex flex-row items-center justify-start gap-2">
                                                        <i className={`text-danger text-[18px] far fa-${document.getFileIcon()}`}/>
                                                        <p className="text-sm line-clamp-1 flex-grow">
                                                            {document.name}
                                                        </p>
                                                    </div>

                                                    <p className="flex-1 text-xxs whitespace-nowrap">
                                                        Uploaded {TB.moment(document.uploaded_at).format('ll')}
                                                    </p>
                                                    <div className="ml-auto">
                                                        {document.id && (
                                                            <a href={document.path} target="_blank"
                                                               className="btn btn-outline-dark btn-outline-white">
                                                                Download
                                                            </a>
                                                        )}


                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <p className="italic">No Documents uploaded yet</p>
                                    )}
                                </div>
                            )}
                        />

                    </Table>
                </div>
            </div>
        </div>
    );
}

export default TeamScopeProposalEditTab;